<script setup>
import { useTopicStore } from "@/stores/useTopicStore";
import DeleteConfirmModal from "@/components/Generics/DeleteConfirmModal.vue";

const emit = defineEmits(["close", "refresh", "notify"]);

const topicStore = useTopicStore();

// ===============================
// Tratamento de erro específico
// ===============================
function buildTopicDeleteError(error) {
  const FOREIGN_KEY_ERROR_STRING =
    "Erro interno ao remover assunto: Cannot delete or update a parent row: a foreign key constraint fails (`litterae`.`texts`, CONSTRAINT `fk_texts_topics` FOREIGN KEY (`topic_id`) REFERENCES `topics` (`topic_id`))";

  const raw =
    error?.response?.data?.message ||
    error?.message ||
    "";

  let userFriendlyMessage =
    "Não é possível excluir esse assunto porque existe TEXTO cadastrado vinculado a ele.";

  const looksLikeFK =
    raw.includes("foreign key constraint fails") ||
    raw.toLowerCase().includes("constraint") ||
    raw.toLowerCase().includes("foreign key");

  if (raw.trim() === FOREIGN_KEY_ERROR_STRING.trim() || looksLikeFK) {
    userFriendlyMessage =
      "Este assunto está vinculado a um ou mais Textos e não pode ser removido.\nPara excluí-lo, remova todos os textos associados a este assunto primeiro.";
  } else if (raw) {
    userFriendlyMessage = raw;
  }

  return userFriendlyMessage;
}

async function onConfirmDelete() {
  try {
    await topicStore.deleteTopicById(topicStore.idTopic);

    topicStore.shouldForcePageOne = true;

    emit("notify", {
      type: "success",
      message: "Assunto apagado com sucesso.",
    });

    emit("refresh");
    emit("close");
  } catch (error) {
    const msg = buildTopicDeleteError(error);

    emit("notify", {
      type: "error",
      message: msg,
    });

    throw new Error(msg);
  }
}
</script>

<template>
  <DeleteConfirmModal
    :show="true"
    title="Apagar Assunto"
    messageTitle="Tem certeza que deseja excluir este assunto?"
    messageSubtitle="Esta ação não pode ser desfeita."
    confirmText="Sim, excluir"
    cancelText="Cancelar"
    loadingText="Apagando..."
    :onConfirm="onConfirmDelete"
    @close="emit('close')"
  />
</template>
